export default function PageDoesNotExist() {
  return (
    <main style={{ padding: '1rem' }} className="page-not-exists">
      <p>Page does not exist.</p>
    </main>
  );
}
